import _ from 'underscore';

import * as TagUtil from 'schemas/tags/TagUtil';
import {SampleGroupSchema} from 'workflows/WorkflowConstants';

import {PreparedSample, PreparedSampleTag, PreparedUISampleGroup} from './PreparedSampleGroupConstants';

export default function makeSampleGroup(tags: Array<PreparedSampleTag> = []): PreparedUISampleGroup {
  return {
    cid: _.uniqueId('sampleGroup'),
    tags,
  };
}

export interface ImportedRow {
  [fieldName: string]: PreparedSample;
}
/**
 * Given rows imported from the BulkAddSampleGroupsFlow, create SampleGroup objects.
 *
 * @param sampleGroupSchema object - the schema of SampleGroups being imported
 * @param importedRow dict with keys being field names on the schema and values being PreparedSample objects
 * @return object a SampleGroup
 */
export function makeSampleGroupFromImportedRow(
  sampleGroupSchema: SampleGroupSchema,
  importedRow: ImportedRow
): PreparedUISampleGroup {
  const tags: Array<PreparedSampleTag> = [];

  for (const field of sampleGroupSchema.fields) {
    const importedSample = importedRow[field.name];
    tags.push({
      ...TagUtil.getInitialTag(field),
      targetSamples: importedSample ? [importedSample] : [],
    });
  }

  return makeSampleGroup(tags);
}
